import React from 'react';
import { ScrollReveal } from './shared';

const ExecutionGapSection = () => {
  return (
    <section className="py-16 sm:py-20 bg-white" data-testid="execution-gap-section">
      <div className="container-luxury">
        <ScrollReveal>
          <div className="max-w-3xl mx-auto text-center">
            <p className="overline mb-4">The Execution Gap</p>
            <p className="font-serif text-2xl sm:text-3xl text-[#0B1A2B] leading-snug">
              Growth decisions often need more extensive market evidence. APIG helps leadership teams validate opportunities, strengthen strategy, and support execution with clearer insight into how customers and markets will respond.
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default ExecutionGapSection;
